module.exports = __webpack_public_path__ + "static/transactionalemail-bodycopy-dont-dac3f1476424f3dd6f6da16a1ae2832e.png";